// extracted by mini-css-extract-plugin
export default {"line":"HeaderMobile_line__CU4ip","main":"HeaderMobile_main__XGV-g"};